import React, { useEffect, useState } from 'react'
import OrderStatusSelectionOption from './OrderStatusSelectionOption'

export default function OrderStatusSelection({ order, defaultStatus, onChange }) {
  const [allStatus, setAllStatus] = useState([])
  useEffect(() => {
    switch (order.status) {
      case 'CONFIRMED':
        setAllStatus([
          // {value:"CONFIRMED", label:"แจ้งโอนแล้ว"},
          // {value:"SUCCESS", label:"ซื้อสำเร็จ"},
          { value: 'CANCEL', label: 'ยกเลิก' },
          // {value:"free", label:"ฟรี"}
        ])
        break
      case 'SUCCESS':
        setAllStatus([
          // {value:"SUCCESS", label:"ซื้อสำเร็จ"},
          { value: 'CANCEL', label: 'ยกเลิก' },
        ])
        break
      case 'CANCEL':
        setAllStatus([{ value: 'CANCEL', label: 'ยกเลิก' }])
        break
      default:
        setAllStatus([
          // {value:"PENDING", label:"รอแจ้งโอน"},
          // {value:"CONFIRMED", label:"แจ้งโอนแล้ว"},
          // {value:"SUCCESS", label:"ซื้อสำเร็จ"},
          { value: 'CANCEL', label: 'ยกเลิก' },
          // {value:"free", label:"ฟรี"}
        ])
    }
    return () => {}
  }, [order])
  return (
    <>
      <div className="btn-group" role="group" aria-label="Basic example" style={{ width: '100%', height: '35px' }}>
        {allStatus.map((status, i) => (
          <OrderStatusSelectionOption
            key={i}
            label={status.label}
            value={status.value}
            selected={defaultStatus === status.value}
            onChange={(value) => onChange(value)}
          />
        ))}
      </div>
    </>
  )
}
